// @flow

import { graphql, useMutation } from 'react-relay';
import { useRouter } from '../../controls/router';
import { getStepNumber } from '../DevelopmentRegistration/DevelopmentRegistration';
import type {
  useSubmitRegistrationUpsertMutation,
  DevelopmentRegistrationFormInput,
} from './__generated__/useSubmitRegistrationUpsertMutation.graphql';

export const useSubmitRegistration = (): [
  (input: DevelopmentRegistrationFormInput, productId: ?string) => void,
] => {
  const [upsertDevelopmentRegistrationForm] =
    useMutation<useSubmitRegistrationUpsertMutation>(
      graphql`
        mutation useSubmitRegistrationUpsertMutation(
          $input: UpsertDevelopmentRegistrationFormInput!
        ) {
          upsertDevelopmentRegistrationForm(input: $input) {
            developmentRegistrationForm {
              id
              step
            }
          }
        }
      `,
    );
  const router = useRouter();

  const submit = (
    input: DevelopmentRegistrationFormInput,
    productId: ?string,
  ) => {
    upsertDevelopmentRegistrationForm({
      variables: {
        input: {
          developmentRegistrationForm: input,
        },
      },
      onCompleted: res => {
        if (res != null) {
          const payload =
            res.upsertDevelopmentRegistrationForm?.developmentRegistrationForm;
          router.push({
            pathname: '/development-registration',
            query: {
              id: payload?.id ?? '',
              step: getStepNumber(payload?.step),
              productId: productId != null ? productId : '',
            },
          });
        }
      },
    });
  };

  return [submit];
};
